import { useState } from 'react';
import { services } from '../data';

const serviceImages = [
  '/assets/service_cockroach.png',
  '/assets/service_general_pest.png',
  '/assets/images/hero_termite.png',
  '/assets/service_rodent.png',
  '/assets/service_general_pest.png',
  '/assets/service_fly.png',
  '/assets/about_pest_control.png',
  '/assets/service_general_pest.png',
  '/assets/service_termite.png',
  '/assets/images/hero_termite.png',
  '/assets/service_bird.png',
];

const serviceMetadata = [
  { icon: 'shield', badge: 'ODORLESS GEL', features: ['100% Odorless', '1-Yr Warranty'] },
  { icon: 'check', badge: 'COLONY ERADICATION', features: ['Colony Eradication', 'Herbal Safe'] },
  { icon: 'zap', badge: 'GENERAL SHIELD', features: ['All Common Pests', 'ISO Certified'] },
  { icon: 'zap', badge: 'BAIT STATIONS', features: ['Tamper-Proof Baits', 'Zero Re-entry'] },
  { icon: 'shield', badge: 'REPELLENT COATING', features: ['Safe Repellent', 'Preventive'] },
  { icon: 'chart', badge: 'UV LIGHT TRAPS', features: ['UV Light Trap', 'FoSTaC Standard'] },
  { icon: 'shield', badge: 'SAFE RELOCATION', features: ['Rescue & Release', 'Emergency'] },
  { icon: 'leaf', badge: 'EXTERIOR CLEARING', features: ['Yard Clearing', 'Long-Lasting'] },
  { icon: 'leaf', badge: '10-YR WARRANTY', features: ['Soil Barrier', 'Ultrasonic Scan'] },
  { icon: 'shield', badge: 'WEB REMOVAL', features: ['Barrier Spray', 'Web Clearing'] },
  { icon: 'document', badge: 'SPIKES & NETTING', features: ['UV Stabilized', 'Zero Harm'] },
];

function SVGIcon({ name, className = 'w-5 h-5' }) {
  const icons = {
    shield: <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />,
    leaf: <path d="M11 20A9 9 0 0 1 2 11c0-4.97 4.03-9 9-9 4.97 0 9 4.03 9 9 0 4.97-4.03 9-9 9zm0-16a7 7 0 0 0-7 7c0 3.87 3.13 7 7 7 3.87 0 7-3.13 7-7 0-3.87-3.13-7-7-7zm-1 9V8h2v5h-2zm0 4v-2h2v2h-2z" />,
    zap: <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />,
    check: <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14M22 4L12 14.01l-3-3" />,
    chart: <path d="M18 20V10M12 20V4M6 20v-6" />,
    document: <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6" />,
  };
  return (
    <svg className={className} fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
      {icons[name] || icons.shield}
    </svg>
  );
}

export default function Services() {
  const [selected, setSelected] = useState(null);

  if (selected) return <ServiceDetail service={selected} back={() => setSelected(null)} />;

  return (
    <main className="bg-bg overflow-hidden">
      {/* Hero */}
      <section className="relative min-h-[380px] sm:min-h-[440px] flex items-center px-4 sm:px-6 md:px-16 py-14 sm:py-20 overflow-hidden bg-gradient-to-b from-primary-dark via-primary to-primary-deep text-white">
        <div className="absolute inset-0 opacity-15 bg-[radial-gradient(var(--color-accent-bright)_1px,transparent_1px)] [background-size:24px_24px] pointer-events-none" />
        <div className="absolute right-[10%] top-[10%] w-72 h-72 rounded-full bg-accent-bright/15 blur-3xl pointer-events-none float-slow" />
        <div className="absolute left-[5%] bottom-[5%] w-60 h-60 rounded-full bg-cta/20 blur-3xl pointer-events-none float-medium" />

        <div className="relative z-10 max-w-3xl mx-auto text-center animate-rise">
          <span className="inline-flex items-center gap-2 px-3.5 sm:px-4 py-1.5 sm:py-2 rounded-full bg-accent/20 text-accent-bright text-[10px] sm:text-xs font-bold tracking-widest uppercase mb-4 sm:mb-5 border border-accent/30 shadow-sm backdrop-blur-md">
            <span className="w-2 h-2 sm:w-2.5 sm:h-2.5 rounded-full bg-accent-bright animate-ping shrink-0" />
            ISO 9001:2015 CERTIFIED SERVICES
          </span>
          <h1 className="font-heading text-3xl sm:text-5xl md:text-6xl font-extrabold leading-tight mb-4 sm:mb-5 tracking-tight">
            Targeted solutions for <span className="text-accent-bright">every space.</span>
          </h1>
          <p className="text-white/80 text-xs sm:text-base md:text-lg leading-relaxed max-w-2xl mx-auto font-normal">
            Specialized pest management for homes, commercial complexes, food processing plants &amp; industrial sites across Maharashtra.
          </p>
        </div>
      </section>

      {/* Curved Divider Top (Hero -> Services Grid) */}
      <div className="w-full overflow-hidden leading-none bg-primary-dark -mt-1 -mb-1 relative z-10 pointer-events-none">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="relative block w-full h-14 text-accent-bright fill-current">
          <path d="M0,0 C150,90 350,-40 500,50 C650,140 900,10 1200,60 L1200,120 L0,120 Z" />
        </svg>
      </div>

      {/* Services Grid */}
      <section className="py-14 sm:py-20 px-4 sm:px-6 md:px-16 bg-surface-alt relative overflow-hidden">
        <div className="max-w-6xl mx-auto relative z-10">
          <div className="text-center mb-10 sm:mb-16">
            <span className="inline-flex items-center gap-2 px-3.5 sm:px-4 py-1.5 rounded-full bg-accent-soft text-accent-muted text-[10px] sm:text-xs font-bold tracking-widest uppercase mb-3 border border-accent/20 shadow-2xs">
              COMPLETE 11-SERVICE RANGE
            </span>
            <h2 className="font-heading text-2xl sm:text-4xl md:text-5xl font-bold text-primary tracking-tight">
              Explore our <span className="text-cta">specialized treatments.</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {services.map((service, index) => {
              const meta = serviceMetadata[index % serviceMetadata.length];
              return (
                <article
                  key={service[0]}
                  onClick={() => setSelected({ ...service, meta, img: serviceImages[index % serviceImages.length] })}
                  className="group p-6 sm:p-7 rounded-[28px] bg-white text-primary border border-slate-200/80 hover:border-cta shadow-md hover:shadow-2xl transition-all duration-700 flex flex-col justify-between cursor-pointer relative overflow-hidden"
                >
                  {/* Perfectly Balanced Smooth Wave (1.2s) */}
                  <div className="absolute bottom-0 right-0 w-[600px] h-[600px] -mb-32 -mr-32 rounded-full bg-gradient-to-tl from-primary-dark via-cta to-primary opacity-0 group-hover:opacity-100 scale-0 group-hover:scale-100 transition-all duration-[1200ms] ease-out origin-bottom-right pointer-events-none z-0 shadow-2xl" />

                  <div className="relative z-10">
                    {/* Top Icon Badge Container */}
                    <div className="w-12 h-12 rounded-2xl bg-accent-soft group-hover:bg-white/20 border border-accent/40 group-hover:border-white/40 text-cta group-hover:text-accent-bright grid place-items-center mb-5 group-hover:scale-110 group-hover:rotate-6 transition-all duration-700 shadow-sm">
                      <SVGIcon name={meta.icon} className="w-6 h-6 fill-current" />
                    </div>

                    <span className="text-[9px] font-extrabold uppercase tracking-widest text-accent-muted group-hover:text-accent-bright block mb-1.5 transition-colors duration-700">
                      {meta.badge}
                    </span>

                    <h3 className="font-heading text-lg sm:text-xl font-extrabold text-primary group-hover:text-white mb-2.5 transition-colors duration-700 leading-snug">
                      {service[0]}
                    </h3>

                    <p className="text-xs text-txt-muted group-hover:text-white/90 leading-relaxed font-normal mb-6 transition-colors duration-700 line-clamp-3">
                      {service[1]}
                    </p>
                  </div>

                  {/* Know More Action Link */}
                  <div className="pt-4 border-t border-slate-100 group-hover:border-white/20 flex items-center justify-between relative z-10">
                    <span className="text-xs font-black text-cta group-hover:text-white transition-colors duration-700 flex items-center gap-1.5">
                      Know More <span className="group-hover:translate-x-1.5 transition-transform duration-700">→</span>
                    </span>
                    <span className="text-[10px] font-bold px-2.5 py-0.5 rounded-full bg-accent-soft group-hover:bg-white/20 text-accent-muted group-hover:text-accent-bright border border-accent/20 group-hover:border-white/30 transition-colors duration-700">
                      ISO Certified
                    </span>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </section>
    </main>
  );
}

function ServiceDetail({ service, back }) {
  return (
    <main className="bg-bg">
      <section className="relative min-h-[380px] sm:min-h-[460px] flex items-center px-4 sm:px-6 md:px-16 py-14 sm:py-20 overflow-hidden bg-gradient-to-b from-primary-dark via-primary to-primary-deep text-white">
        <div className="absolute inset-0 opacity-15 bg-[radial-gradient(#ace05c_1px,transparent_1px)] [background-size:24px_24px] pointer-events-none" />

        <div className="relative z-10 md:px-16 max-w-5xl mx-auto animate-rise">
          <button onClick={back} className="mb-5 sm:mb-6 inline-flex items-center gap-2 text-xs font-bold text-[#ace05c] bg-white/10 px-3.5 sm:px-4 py-2 rounded-xl border border-white/20 hover:bg-white/20 transition-all cursor-pointer">
            ← Back to All Services
          </button>

          <div className="mb-3.5">
            <span className="inline-flex items-center gap-2 px-3.5 sm:px-4 py-1.5 rounded-full bg-accent/20 text-[#ace05c] text-[10px] sm:text-xs font-bold tracking-widest uppercase border border-[#ace05c]/30 shadow-2xs">
              PREMIUM PEST MANAGEMENT
            </span>
          </div>

          <h1 className="font-heading text-3xl sm:text-5xl font-extrabold leading-tight mb-4 tracking-tight">
            {service[0]} <span className="text-[#ace05c]">done properly.</span>
          </h1>
          <p className="text-white/80 text-xs sm:text-base md:text-lg leading-relaxed mb-6 sm:mb-8 max-w-2xl font-normal">
            {service[1]} Our certified specialists conduct detailed inspections and execute tailored, odorless treatment pathways engineered for long-term protection.
          </p>
          <a className="btn-flash inline-flex items-center justify-center gap-3 bg-cta hover:bg-cta-hover text-white font-bold text-xs sm:text-sm px-6 sm:px-8 py-3.5 sm:py-4 rounded-2xl glow-cta transition-all no-underline w-full sm:w-auto text-center" href="tel:+918788895445">
            Book Inspection Call →
          </a>
        </div>
      </section>

      <section className="py-14 sm:py-20 px-4 sm:px-6 md:px-16 max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12 items-start">
        <div>
          <span className="inline-flex items-center gap-2 px-3.5 sm:px-4 py-1.5 rounded-full bg-accent-soft text-accent-muted text-[10px] sm:text-xs font-bold tracking-widest uppercase mb-3.5 border border-accent/20 shadow-2xs">
            OUR EXECUTION APPROACH
          </span>
          <h2 className="font-heading text-2xl sm:text-3xl font-bold text-primary leading-tight mb-3.5 tracking-tight">
            Carefully planned. <span className="text-cta">Expertly delivered.</span>
          </h2>
          <p className="text-xs sm:text-sm text-txt-muted leading-relaxed mb-6 font-medium">
            We use government-approved, odorless treatment practices designed specifically for your property layout, operating hours, and strict FSSAI / ISO compliance standards.
          </p>

          <div className="space-y-3">
            {[
              'Thorough premises scan to detect nest points',
              'Custom odorless gel & micro-encapsulated spray',
              'Scheduled follow-up audits & multi-year warranty'
            ].map((step, i) => (
              <div key={i} className="flex items-center gap-3 p-3 sm:p-3.5 rounded-2xl bg-white border border-slate-200 shadow-2xs">
                <span className="w-7 h-7 sm:w-8 sm:h-8 rounded-xl bg-accent-soft text-cta font-bold text-xs grid place-items-center shrink-0">
                  0{i + 1}
                </span>
                <span className="text-xs font-semibold text-primary">{step}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="card-3d-gem p-6 sm:p-8 rounded-3xl relative bg-white border border-slate-200 shadow-md">
          <b className="font-heading text-lg sm:text-xl block text-primary mb-4 sm:mb-5 border-b border-slate-100 pb-3">
            What's included in treatment
          </b>
          {[
            'Detailed premises scan & nest detection',
            '100% Odorless government-approved products',
            'Complete safety guidance for occupants',
            'Written multi-year warranty certificate',
            'Scheduled follow-up audits'
          ].map((x) => (
            <p key={x} className="border-b border-slate-100 pb-3 mb-3 text-xs text-primary font-semibold flex items-center gap-2.5">
              <span className="w-4 h-4 sm:w-5 sm:h-5 rounded-full bg-accent-soft text-cta grid place-items-center text-[10px] font-bold shrink-0">✓</span>
              {x}
            </p>
          ))}
        </div>
      </section>
    </main>
  );
}
